// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 创建菜单 POST /api/v1/hq/menu */
export async function HqMenuControllerCreateV1(
  body: MyApi.CreateMenuDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputMenuDto>("/api/v1/hq/menu", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 更新菜单 PUT /api/v1/hq/menu/${param0} */
export async function HqMenuControllerUpdateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqMenuControllerUpdateV1Params,
  body: MyApi.UpdateMenuDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputMenuDto>(`/api/v1/hq/menu/${param0}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 删除菜单 DELETE /api/v1/hq/menu/${param0} */
export async function HqMenuControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqMenuControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(`/api/v1/hq/menu/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 批量排序菜单 PUT /api/v1/hq/menu/reorder */
export async function HqMenuControllerReorderV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqMenuControllerReorderV1Params,
  body: MyApi.ReorderMenuDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputMenuDtoArray>(
    "/api/v1/hq/menu/reorder",
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        ...params,
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取菜单树 GET /api/v1/hq/menu/tree */
export async function HqMenuControllerTreeV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqMenuControllerTreeV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputMenuDtoArray>("/api/v1/hq/menu/tree", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
